<script setup>
import { useUserStore } from '@/stores/user'
import { useRouter, useRoute} from 'vue-router'
const userStore = useUserStore()
import { useMainStore } from '@/stores/main'
let mainStore = useMainStore()

import { onMounted,ref } from 'vue'
import Slideover from '../../../components/SlideOver/slideover.vue'
import CreateForm from '../../../components/SlideOver/forms/CreateApiKey.vue'
import User from '../../../api/User';
import moment from 'moment'
import Card from '../../../components/Card.vue'

const keys = ref([])

const show_slideover = ref(false)
const slideover_component = ref(null)
const slideover_props = ref(null)


onMounted(async () => {
  keys.value = (await User.list_api_keys()).data;
})


async function close() {
  show_slideover.value = false
  keys.value = (await User.list_api_keys()).data;
}

function show_create_key() {
  mainStore.show_slideover(CreateForm, { },)
}

async function click_handler(id) {
  await User.delete_api_key(id)
  keys.value = (await User.list_api_keys()).data;
}

mainStore.event_on("created_apikey", async () => {
  keys.value = (await User.list_api_keys()).data;
})

</script>

<template>
  <div class="apikeys-content">
    <!-- Empty State -->
    <div v-if="keys.length === 0" class="empty-state">
      <font-awesome-icon :icon="['fas', 'key']" class="empty-icon" />
      <p class="empty-title">No API Keys</p>
      <p class="empty-description">You don't have any active API keys yet. Create one to get started.</p>

      <!-- Add API Key Button (inside empty state) -->
      <button class="add-key-btn" @click="show_create_key()">
        <font-awesome-icon :icon="['fas', 'plus']" class="me-2" />
        Create API Key
      </button>
    </div>

    <!-- API Keys List -->
    <div v-else class="keys-list">
      <div
        v-for="key in keys"
        :key="key.Id"
        class="key-card"
      >
        <div class="key-info">
          <div class="key-name">{{ key.Name }}</div>
          <div class="key-description">{{ key.Description }}</div>
        </div>
        <button class="delete-btn" @click="click_handler(key.Id)" title="Delete API key">
          <font-awesome-icon :icon="['fas', 'trash']" />
        </button>
      </div>

      <!-- Add API Key Button (below list when keys exist) -->
      <button class="add-key-btn" @click="show_create_key()">
        <font-awesome-icon :icon="['fas', 'plus']" class="me-2" />
        Create API Key
      </button>
    </div>
  </div>
</template>

<style scoped>
.apikeys-content {
  padding: 0;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
}

.empty-icon {
  font-size: 3rem;
  color: #6b7280;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.empty-title {
  font-size: 1rem;
  font-weight: 600;
  color: #9ca3af;
  margin: 0 0 0.5rem 0;
}

.empty-description {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0 0 1.5rem 0;
}

/* Keys List */
.keys-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 2rem;
}

.key-card {
  background: rgba(26, 29, 36, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.2s ease;
}

.key-card:hover {
  background: rgba(168, 85, 247, 0.08);
  border-color: rgba(168, 85, 247, 0.3);
}

.key-info {
  flex: 1;
  min-width: 0;
}

.key-name {
  color: #E5E7EB;
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
}

.key-description {
  color: #9CA3AF;
  font-size: 0.875rem;
}

.delete-btn {
  background: transparent;
  border: 1px solid transparent;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}

.delete-btn:hover {
  color: #ef4444;
  border-color: rgba(239, 68, 68, 0.3);
  background: rgba(239, 68, 68, 0.1);
}

/* Add Key Button */
.add-key-btn {
  padding: 0.5rem 1rem;
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #6B7280;
  border-radius: 0.5rem;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.add-key-btn:hover {
  background-color: rgba(255, 255, 255, 0.05);
  color: #E5E7EB;
}

/* Prevent button from stretching when in keys-list */
.keys-list .add-key-btn {
  align-self: flex-start;
}
</style>
